import { rpcSlice } from '../../../store/api/rpcSlice';

export interface AdminMemberLifecycleStateShape {
  name: string;
  rank: number;
  terminal: boolean;
}

export interface AdminMemberLifecycleEffectiveStatus {
  primary: string;
  overlays?: string[];
}

export interface AdminMemberLifecycleState {
  kind: string;
  entityType: string;
  entityId: string;
  version: number;
  sequenceNumber: number;
  state: AdminMemberLifecycleStateShape;
  effectiveStatus?: AdminMemberLifecycleEffectiveStatus;
}

export interface AdminMemberLifecycleOverlay {
  paused: boolean;
  pauseSource: string;
  hubspotContactId?: string;
  hubspotCustomerLifecycleStage?: string;
  dateUnpaused?: string;
  lastSyncedAt: string;
}

export interface AdminMemberLifecycleTransitionItem {
  idempotencyKey: string;
  trigger: string;
  fromState: string;
  toState: string;
  fromRank: number;
  toRank: number;
  metadata?: Record<string, unknown>;
  createdAt: string;
}

export interface AdminMemberLifecycleTransitionPage {
  items: AdminMemberLifecycleTransitionItem[];
  page: number;
  per: number;
  hasMore: boolean;
}

export interface AdminMemberLifecycleAdjustmentItem {
  id: string;
  personId: string;
  adjustmentType: string;
  previousMachineInstanceId?: string;
  newMachineInstanceId?: string;
  previousState?: string;
  newState?: string;
  previousOverlayPaused?: boolean;
  newOverlayPaused?: boolean;
  trigger?: string;
  idempotencyKey?: string;
  actorPersonId: string;
  reason: string;
  referenceUrl?: string;
  metadata?: Record<string, unknown>;
  createdAt: string;
}

export interface AdminMemberLifecycleAdjustmentPage {
  items: AdminMemberLifecycleAdjustmentItem[];
  page: number;
  per: number;
  hasMore: boolean;
}

export interface AdminMemberLifecycleResponse {
  personId: string;
  state?: AdminMemberLifecycleState;
  overlay?: AdminMemberLifecycleOverlay;
  transitions: AdminMemberLifecycleTransitionPage;
  adminAdjustments: AdminMemberLifecycleAdjustmentPage;
}

export interface GetAdminMemberLifecycleRequest {
  personId: string;
  transitionPage?: number;
  transitionPer?: number;
  adjustmentPage?: number;
  adjustmentPer?: number;
}

export function buildAdminMemberLifecycleQuery({
  personId,
  transitionPage,
  transitionPer,
  adjustmentPage,
  adjustmentPer,
}: GetAdminMemberLifecycleRequest) {
  return {
    url: `/lifecycle/admin/member-lifecycle/${encodeURIComponent(personId)}`,
    method: 'GET' as const,
    params: {
      ...(transitionPage ? { transitionPage } : {}),
      ...(transitionPer ? { transitionPer } : {}),
      ...(adjustmentPage ? { adjustmentPage } : {}),
      ...(adjustmentPer ? { adjustmentPer } : {}),
    },
  };
}

export const memberLifecycleApi = rpcSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAdminMemberLifecycle: builder.query<
      AdminMemberLifecycleResponse,
      GetAdminMemberLifecycleRequest
    >({
      query: buildAdminMemberLifecycleQuery,
    }),
  }),
});

export const { useGetAdminMemberLifecycleQuery } = memberLifecycleApi;
